module.exports = __webpack_public_path__ + "static/media/mountain_biking_tiny.29c486ea.webp";